// src/constants/instruments.js

// --- Forex: [value, label] (value = symbol used in forms) ---
export const FOREX_PAIRS = [
  // --- Major Pairs ---
  ["EURUSD", "EUR/USD"],
  ["GBPUSD", "GBP/USD"],
  ["USDJPY", "USD/JPY"],
  ["USDCHF", "USD/CHF"],
  ["AUDUSD", "AUD/USD"],
  ["USDCAD", "USD/CAD"],
  ["NZDUSD", "NZD/USD"],

  // --- Minor Pairs ---
  ["EURGBP", "EUR/GBP"],
  ["EURJPY", "EUR/JPY"],
  ["EURCHF", "EUR/CHF"],
  ["EURAUD", "EUR/AUD"],
  ["EURNZD", "EUR/NZD"],
  ["EURCAD", "EUR/CAD"],
  ["GBPJPY", "GBP/JPY"],
  ["GBPCHF", "GBP/CHF"],
  ["GBPAUD", "GBP/AUD"],
  ["GBPNZD", "GBP/NZD"],
  ["GBPCAD", "GBP/CAD"],
  ["AUDJPY", "AUD/JPY"],
  ["AUDNZD", "AUD/NZD"],
  ["AUDCAD", "AUD/CAD"],
  ["AUDCHF", "AUD/CHF"],
  ["NZDJPY", "NZD/JPY"],
  ["NZDCAD", "NZD/CAD"],
  ["NZDCHF", "NZD/CHF"],
  ["CADJPY", "CAD/JPY"],
  ["CADCHF", "CAD/CHF"],
  ["CHFJPY", "CHF/JPY"],

  // --- Exotics (selected popular) ---
  ["USDSEK", "USD/SEK"],
  ["USDNOK", "USD/NOK"],
  ["USDDKK", "USD/DKK"],
  ["USDMXN", "USD/MXN"],
  ["USDZAR", "USD/ZAR"],
  ["USDHKD", "USD/HKD"],
  ["USDSGD", "USD/SGD"],
  ["USDTRY", "USD/TRY"],



  // --- Metals ---
  ["XAUUSD", "Gold"],
  ["XAGUSD", "Silver"],
  ["XPTUSD", "Platinum"],
  ["XPDUSD", "Palladium"]
];

// --- Index CFDs (value = symbol you store) ---
export const FOREX_INDICES = [
  ["US30",   "US30"],
  ["NAS100", "NASDAQ"],
  ["SPX500", "S&P 500"],
  ["US2000", "Russell"],
  ["GER40",  "DAX"],
  ["JP225",  "Nikkei"],
];

// Convenience combined list (pairs + indices)
export const ALL_FOREX = [...FOREX_PAIRS, ...FOREX_INDICES];

// Small helper
export const isIndexSymbol = (s) => {
  const sym = String(s || "").toUpperCase();
  return FOREX_INDICES.some(([v]) => v === sym);
};


// --- Futures: [value, label] (value is what your form stores) ---
export const FUTURES_PRODUCTS = [
  ["YM - Dow - $5.00", "YM - US30 - $5.00"],
  ["MYM - Dow Micro - $0.50", "MYM - US30 Micro - $0.50"],
  ["ES - SXP 500 - $12.50", "ES - SXP 500 - $12.50"],
  ["MES - SXP 500 Micro - $1.25", "MES - SXP 500 Micro - $1.25"],
  ["NQ - NAS - $5.00", "NQ - NAS - $5.00"],
  ["MNQ - NAS Micro - $0.50", "MNQ - NAS Micro - $0.50"],
  ["GC - Gold - $10.00", "GC - Gold - $10.00"],
  ["MGC - Gold Micro - $1.00", "MGC - Gold Micro - $1.00"],
  ["NG - Natural Gas - $10.00", "NG - Natural Gas - $10.00"],
  ["MNG - N.Gas Gas Micro - $1.00", "MNG - N. Gas Micro - $1.00"],
  ["CL - Oil - $10.00", "CL - Oil - $10.00"],
  ["MCL - Oil Micro - $1.00", "MCL - Oil Micro - $1.00"],
  ["RT - Russell - $5.00", "RT - Russell - $5.00"],
  ["M2K - Russell Micro - $0.50", "M2K - Russell Micro - $0.50"],
  ["SI - Silver - $25.00", "SI - Silver - $25.00"],
  ["SIL - Silver Micro - $5.00", "SIL - Silver Micro - $5.00"],
  ["HG - Copper - $25.00", "HG - Copper - $12.50"],
  ["MHG - Copper Micro - $5.00", "MHG - Copper Micro - $1.25"],
  ["6E - Euro FX Futures - $6.25", "6E - Euro FX Futures - $6.25"],
  ["M6E - Euro FX Micro - $1.25", "M6E - Euro FX Micro - $1.25"],
  ["6B - B. Pound - $6.25", "6B - B. Pound - $6.25"],
  ["M6B - Micro B. Pound - $0.60", "M6B - Micro B. Pound - $0.60"],
  ["6C - Canadian Dollar - $5.00", "6C - Canadian Dollar - $5.00"],
  ["6J - Japanese Yen - $6.25", "6J - Japanese Yen - $6.25"],
  ["6S - Swiss Franc - $6.25", "6S - Swiss Franc - $6.25"],
  ["HE - Lean Hog - $10.00", "HE - Lean Hog - $10.00"],
  ["GF - Feeder Cattle - $12.50", "GF - Feeder Cattle - $12.50"],
  ["LE - Live Cattle - $10.00", "LE - Live Cattle - $10.00"],
  ["BTC - Bitcoin - $25.00", "BTC - Bitcoin - $25.00"],
  ["MBT - Micro Bitcoin - $0.50", "MBT - Micro Bitcoin - $0.50"],
  ["ZS - Soybean - $12.50", "ZS - Soybean - $12.50"],
  ["XK - Mini Soybean - $1.25", "XK - Mini Soybean - $1.25"],
  ["ZW - Wheat - $12.50", "ZW - Wheat - $12.50"],
  ["MZW - Micro Wheat - $2.50", "MZW - Micro Wheat - $2.50"],
  ["ZC - Corn - $12.50", "ZC - Corn - $12.50"],
  ["MZC - Corn Mircro - $2.50", "MZC - Corn Mircro - $2.50"],
  ["ZF - 5 Year T-Note - $7.81", "ZF - 5 Year T-Note - $7.81"],
  ["ZN - 10 Year T-Note - $15.62", "ZN - 10 Year Note - $15.62"],
  ["ZT - 2 Year Note - $7.81", "ZT - 2 Year Note - $7.81"],
  ["TN - 10 YR Note - $15.63", "TN - 10 YR Note - $15.63"],
  ["MTN - 10 YR N. Micro - $1.56", "MTN - 10 YR N. Micro - $1.56"],
  
];

// Helper: pull the short futures symbol (e.g., "YM") from the value string
export const futuresCodeOf = (value) => String(value).split(" - ")[0];


// --- Index CFDs (value = symbol you store) ---
// export const FOREX_INDICES = [
//   ["US30",   "US30 (Dow)"],
//   ["NAS100", "NASDAQ 100"],
//   ["SPX500", "S&P 500"],
//   ["US2000", "Russell 2000"],
//   ["GER40",  "DAX 40"],
//   ["UK100",  "FTSE 100"],
//   ["FRA40",  "CAC 40"],
//   ["JP225",  "Nikkei 225"],
//   ["HK50",   "Hang Seng"],
//   ["AUS200", "ASX 200"]
// ];
